<template lang="pug">
  base-content(title="ページが見つかりませんでした")
    .content.has-text-centered
      p
        | 恐れ入りますが、
        router-link(:to="{name: 'home'}") TOPページ
        | からもう一度やり直すか、
        a(href="#" @click.prevent="$router.go(-1)") 前のページ
        | にお戻りください。
</template>

<script>
import BaseContent from '@/components/BaseContent'
export default {
  name: 'page-not-found',
  components: { BaseContent }
}
</script>

<style scoped>
h2.headline {
  margin: 0;
  width: 170px;
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/components/PageNotFound.vue